import React from "react";
import moment from "moment";
import FolderCard from "./FolderCard";
import { getWaitingTime } from "utils/dateUtils";
import { useSafePolling } from "hooks/useSafePolling";

const FoldersList = ({
	hideList,
	list,
	generalParameters,
	filters,
	t,
	user,
	refreshFolders,
	selectPatient,
	openFolder,
	doneFolderHelp,
	getAllPrescriptionScans,
	showIdentityVigilancePopUp,
	nurseApp = false,
}) => {
	const getMaxMinutesAliquots = (center) => {
		if (!center) return 0;
		if (center.aliquotLevel === "MINUS8") return 480;
		if (center.aliquotLevel === "MINUS6") return 360;
		if (center.aliquotLevel === "MINUS4") return 240;
		if (center.aliquotLevel === "MINUS2") return 120;
		return 0;
	};
	useSafePolling(refreshFolders, {
		delay: 20000,
		timeoutThreshold: 20000,
		enabled: !!refreshFolders && !hideList,
	});

	const getAppointmentToOpen = () => {
		if (list) {
			const appointment = list.find((item) => item.folder?.openedBy === null || item.folder?.openedBy?.id === user?.session?.id);
			return appointment?.id;
		}
		return 0;
	};

	const getSamplingTimerTube = (folder) => {
		if (
			folder &&
			folder.prescriptions &&
			folder.prescriptions.length > 0 &&
			folder.prescriptions.some((p) => p.tubes && p.tubes.some((t) => t.sampling_time && t.properties.timer_before_result > 0))
		) {
			let tubes = folder.prescriptions.find((p) => p.tubes && p.tubes.some((t) => t.sampling_time && t.properties.timer_before_result > 0)).tubes;
			if (tubes && tubes.filter((t) => t.sampling_time && t.properties.timer_before_result > 0).length > 0)
				return tubes.filter((t) => t.sampling_time && t.properties.timer_before_result > 0)[0];
		}
		return null;
	};

	const getWaitingTimeBeforeSampling = (folder) => {
		if (folder && folder.prescriptions) {
			let tubes = Array.prototype.concat(...folder.prescriptions.map((p) => p.tubes));
			//S'il reste des tubes à prélever
			if (tubes && tubes.filter((t) => t && t.sampling_time).length > 0 && tubes.filter((t) => !t.sampling_time).length > 0) {
				let firstSampling = tubes
					.filter((t) => t.sampling_time)
					.sort((a, b) => new Date(a.sampling_time) - new Date(b.sampling_time))
					.map((t) => t.sampling_time)[0];
				let nextTimer = tubes
					.filter((t) => !t.sampling_time && t.properties.timer > 0)
					.sort((t) => t.properties.timer)
					.map((t) => t.properties.timer)[0];
				var result = getWaitingTime(moment().toDate(), moment(firstSampling).add(nextTimer, "m").toDate());
				if (result === "" || result === "maintenant") return " "; // en attente
				return result;
			}
		}
		return "";
	};

	return (
		<>
			{!hideList &&
				list
					.filter((item) => {
						// previous rule was
						// return item.folder && (filters.showDone ? true : item.status !== "DONE" && item.status !== "CANCELED")

						if (!item.folder) {
							return nurseApp;
						}

						// @see NURSE-290 Disallow temp folder from preregistration in this list
						// Avoid collision with other flow
						if (!item.folder.is_express && !!item.folder.is_temp && user?.session?.role === "NURSE") {
							return false;
						}

						if (item.status === "DONE" || item.status === "CANCELED") {
							return !!filters.showDone;
						}

						return true;
					})
					.sort((a, b) => {
						if (a.folder && b.folder && !!a.folder.openedBy !== !!b.folder.openedBy) return !!a.folder.openedBy ? 1 : -1;
						if (!!getSamplingTimerTube(a.folder) !== !!getSamplingTimerTube(b.folder)) return !!getSamplingTimerTube(a.folder) ? 1 : -1;
						if (a._date !== b._date) {
							return moment(a._date).isAfter(b._date, "date") ? 1 : -1;
						} else {
							if (a._time && b._time) {
								const a_hour = Number(a._time.substring(0, 2));
								const b_hour = Number(b._time.substring(0, 2));

								if (a_hour !== b_hour) {
									return a_hour - b_hour;
								} else {
									const a_min = Number(a._time.substring(3, 2));
									const b_min = Number(b._time.substring(3, 2));

									return a_min - b_min;
								}
							}
							return 0;
						}
					})
					.map((l, index) => (
						<FolderCard
							key={"folder" + index}
							t={t}
							folder={l.folder}
							labAppointment={l}
							index={index}
							generalParameters={generalParameters}
							appointmentToOpen={getAppointmentToOpen()}
							user={user}
							selectPatient={selectPatient}
							openFolder={openFolder}
							timer={getWaitingTimeBeforeSampling(l.folder)}
							fastResultTube={getSamplingTimerTube(l.folder)}
							withAliquot={l.center && l.center.aliquotLevel !== "NOALIQUOT"}
							maxMinutesForAliquot={getMaxMinutesAliquots(l.center)}
							displayCenter={filters.centers}
							displayBox={filters.box}
							doneFolderHelp={doneFolderHelp}
							getAllPrescriptionScans={getAllPrescriptionScans}
							showIdentityVigilancePopUp={showIdentityVigilancePopUp}
						/>
					))}
		</>
	);
};

export default FoldersList;
